<template>
    <div class="load-mask-parent" v-show="show">
        <div :class="loadMask"></div>
        <form>
            <template v-for="(input, index) in inputs || []">
                <div class="row">
                    <div class="col-lg-12">
                        <component
                            :is="getComponentName(input.type)"
                            :label="input.label"
                            :name="input.name"
                            :event-bus="eventBus"
                            :parentIndex="config.index"
                            v-model="input.value"
                            :value="input.value"
                            :config="input"
                        ></component>
                    </div>
                </div>
            </template>
            <button class="btn btn-success" @click.prevent="submit">{{ t('Submit') }}</button>
        </form>
    </div>
</template>
<script>

import Vue from "vue";
import ComponentTitle from "./ComponentTitle";
import ValueChecker from "../services/ValueChecker";

export default {
    components: {ComponentTitle},
    props: {
        config: {
            Type: Object,
            default: function() {
                return {
                    actionButtons: [],
                    isDumpActive: false,
                }
            }
        },
        eventBus: {
            Type: Object,
        },
        extraData: {
            Type: Object,
        },
        index: {
            Type: String
        },
        moduleConfig: {
            Type: Object
        },
        routeName: {
            Type: String,
            require: true,
        },
        rowIndex: {
            Type: Number,
        },
    },
    computed: {
    },
    data()
    {
        return {
            loadMask: '',
            inputs: [],
            show: true,
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    mounted()
    {
        this.mountEvents();
        this.inputs = this.config.inputs;
        let extraData = Object.assign({}, this.extraData);
        this.loadData(extraData);
    },
    methods: {
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        findActionByName(name) {
            return (this.config.actions || []).find(v => {
                return v.name === name;
            });
        },
        loadData(extraData) {
            let params = extraData;
            let action = this.findActionByName('loadAction');

            if (ValueChecker.isUndefinedOrNull(action)) {
                return;
            }

            let url = action.url;
            let method = action.method;
            this.addLoadMask();
            let data = {};

            this.$http[method](url, params).then(response => {
                data = response.data.data[0];
                this.$children.forEach(c => {
                    c.setValue({},data);
                });

                this.inputs.forEach(input => {
                    input.value = data[input.name];
                });
                this.removeLoadMask();

            });
        },
        getComponentName(componentName) {
            return require(`./form/${componentName}.vue`);
        },
        mountEvents() {
            let eventManagerService = this.$root.getEventManager();
            eventManagerService.bindEvents(this.config.bindEvents, this);

            this.$root.$on('load-data-component', (config, data) => {
                this.loadData(data);
            });
        },
        unmountEvents() {
            this.$root.$off('load-data-component');
        },
        serialize(inputs) {
            let res = {};
            inputs.forEach(v => {
                res[v.name] = v.value;
            });

            return res;
        },
        showComponent(componentIndex) {
            if (this.config.index === componentIndex) {
                this.show = !this.show;
                this.eventBus.$emit('FormComponent:show-component');
            }
        },
        submit() {
            this.addLoadMask();
            let eventManagerService = this.$root.getEventManager();
            let res = this.serialize(this.inputs);
            let params = JSON.stringify(res);
            let method = 'post';
            let url = this.routeName + '/submit';
            let action = this.findActionByName('submitAction');

            if (action) {
                url = action.url;
                method = action.method;
            }

            let emitEvents = this.config.emitEvents;

            if (ValueChecker.isUndefinedOrNull(emitEvents)) {
                emitEvents = {
                    'submit' : [{
                        type: 'frontend',
                        config: {
                            eventName: 'user-dt:loadData',
                        },
                    }]
                };
            }

            this.$http.post(url, params).then(response => {
                this.removeLoadMask();
                eventManagerService.emitEvents(emitEvents['submit'] || [], [response.data]);
            }, (response) => {
                this.removeLoadMask();
                let errors = response.data.errors;
                this.eventBus.$emit('FormComponent:submit-errors', errors);
            });
        }
    }
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// FormComponent.vue?37071fd6